/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_NEUTRAL_WHITE } from '../../styles';
export var StyledHeaderLogoLink = styled('a')({
  '&.EmbersHeader-logo': {
    height: 36,
    margin: '0 14px',
    border: '2px solid transparent',
    '&.clickable': {
      cursor: 'pointer'
    },
    '&:focus-visible': {
      borderColor: PROMETHEAN_NEUTRAL_WHITE
    }
  }
});